<div [ngClass]="isMobile ? 'mobile' : ''">
  <div id="mobileTitle" class="title">
    <typography variant="mat-headline-4" weight="bold"> {{ title }}</typography>
  </div>

  <!-- Loading Spinner -->
  @if (isLoadingData) {
    <div id="leadLoading" class="overlay full">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  <form [formGroup]="leadForm" id="main-form-editLead">
    <ds-paper id="businessDetailsSectionPaper" elevation="elevation_none" outline="outlined"
      [insidePaddingTop]="isMobile ? 'top-spacing_L' : 'top-spacing_XL'"
      [insidePaddingBottom]="isMobile ? 'bottom-spacing_L' : 'bottom-spacing_XL'"
      [insidePaddingLeft]="isMobile ? '' : 'left-spacing_XL'"
      [insidePaddingRight]="isMobile ? '' : 'right-spacing_XL'">
      <typography id="businessSectionTitle" variant="mat-subtitle-1" weight="medium">{{ appStrings.lead_businessSection_title }}</typography>
      <div class="divider">
        <ds-divider></ds-divider>
      </div>
      <div class="fields-container">
        <ds-autocomplete id="accountManagerField" class="fill-width quarter-width no-subscript" [label]="isNewDelivery || isDeliveryEditMode ? appStrings.quoteDetails_AccountManager : appStrings.followUp_leads_leadOwner" label_orientation="vertical-label"
          [options]="displayAccountManagerList || []" [control]="leadForm.controls.accountManager" [isDisabled]="!isOnline || disableEditDelivery || !canEdit"
          (selectionChange)="selectedAccountManager($event)" drop_icon="search">
        </ds-autocomplete>
        <ds-autocomplete id="companyField" class="fill-width fill-gap half-width no-subscript" [label]="appStrings.accounts_company" label_orientation="vertical-label"
          [options]="companiesList || []" [control]="leadForm.controls.company" [isDisabled]="!isOnline || disableEditDelivery || !canEdit"
          (selectionChange)="confirmCompanyChange($event)" fullFilter="true" [maxLength]="maxLengthsInputs.company">
        </ds-autocomplete>
        @if (isNewLead || isLeadEditMode) {
          <ds-select id="sourceField" class="fill-width quarter-width no-subscript" [label]="appStrings.followUp_leads_source" label_orientation="vertical-label"
            [dropOptions]="displaySourcesList || []" [control]="leadForm.controls.sourceTypeId" [isDisabled]="!isOnline || disableEditDelivery || !canEdit">
          </ds-select>
        }
        <div class="address-divider">
          <ds-divider></ds-divider>
        </div>
        <ds-textfield id="primaryAddressField" class="fill-width fill-gap half-width no-subscript" [label]="appStrings.contacts_addressLine1" label_orientation="vertical-label"
          [control]="addressFormGroup.controls.addressline1" [isDisabled]="!isOnline || disableEditDelivery || !canEdit" maxlength="30">
        </ds-textfield>
        <ds-textfield id="secondaryAddressField" class="fill-width fill-gap half-width no-subscript" [label]="appStrings.contacts_addressLine2" label_orientation="vertical-label"
          [control]="addressFormGroup.controls.addressline2" [isDisabled]="!isOnline || disableEditDelivery || !canEdit" maxlength="30">
        </ds-textfield>
        <ds-select id="countryField" class="fill-width quarter-width no-subscript" [label]="appStrings.contacts_country" label_orientation="vertical-label"
          [dropOptions]="displayCountryList || []" [control]="addressFormGroup.controls.countryId" [isDisabled]="!isOnline || disableEditDelivery || !canEdit"
          (selectionChange)="handleCountryChanged($event)">
        </ds-select>
        @if (!countryWithCounty && !countryWithHiddenStateProvince) {
          @if (templateValues.states[leadForm.value.address?.countryId]) {
            <ds-select id="stateField" class="fill-width quarter-width no-subscript" [label]="appStrings.contacts_state_province" label_orientation="vertical-label"
              [dropOptions]="displayStatesList || []" [control]="addressFormGroup.controls.stateId" [isDisabled]="!isOnline || disableEditDelivery || !canEdit">
            </ds-select>
          } @else {
            <ds-textfield id="stateField" class="fill-width quarter-width no-subscript" [label]="appStrings.contacts_state_province" label_orientation="vertical-label"
              [control]="addressFormGroup.controls.province.controls.name" [isDisabled]="!isOnline || disableEditDelivery || !canEdit">
            </ds-textfield>
          }
        }
        <div class="city-zip-row">
          <ds-textfield id="cityField" class="fill-width quarter-width no-subscript city-field" [label]="appStrings.contacts_city" label_orientation="vertical-label"
            [control]="addressFormGroup.controls.city" [isDisabled]="!isOnline || disableEditDelivery || !canEdit" maxlength="30">
          </ds-textfield>
          <ds-textfield id="zipField" class="fill-width fill-gap quarter-width no-subscript zip-field" [label]="contactsZipOrPostalCode" label_orientation="vertical-label"
            [control]="addressFormGroup.controls.zip" [isDisabled]="!isOnline || disableEditDelivery || !canEdit" maxlength="10">
          </ds-textfield>
        </div>
        @if (countryWithCounty) {
          <ds-select id="regionField" class="fill-width quarter-width no-subscript" [label]="appStrings.contacts_region" label_orientation="vertical-label"
            [dropOptions]="displayRegionList" [control]="addressFormGroup.controls.regionId" [isDisabled]="!isOnline || disableEditDelivery || !canEdit"
            (selectionChange)="handleRegionChanged($event)">
          </ds-select>
        }
        @if (addressFormGroup.value.regionId) {
          <ds-autocomplete id="countyField" class="fill-width quarter-width no-subscript" [label]="appStrings.contacts_county" label_orientation="vertical-label"
            [options]="displayCountyList || []" [control]="addressFormGroup.controls.countyId" [isDisabled]="!addressFormGroup.controls.regionId.value"
            (selectionChange)="checkSelectedCounty($event)">
          </ds-autocomplete>
        }
      </div>
    </ds-paper>
  </form>

  @if (leadType !== 'Delivery' && !isLeadEditMode && !isDeliveryEditMode) {
    <app-contacts-dashboard
    [addressSource]="leadForm.controls.address"></app-contacts-dashboard>
  }
</div>